import script from "./MiniaturesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MiniaturesSection.vue?vue&type=script&setup=true&lang=ts"

import "./MiniaturesSection.vue?vue&type=style&index=0&id=726f9f83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726f9f83"]])

export default __exports__